// extracted by mini-css-extract-plugin
export default {"body":"ArticleBody_body__Lmsjm"};